export default __webpack_public_path__ + "static/media/cesto_peperoni.05129c92.svg";